import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  
  year: number;

  constructor() { 
    this.year = new Date().getFullYear();
  }

  ngOnInit() {}

}



// WEBPACK FOOTER //
// /Users/jonshilton/Projects/nick-smith-app/src/app/components/footer/footer.component.ts